module.exports = __webpack_public_path__ + "media/icons/search-2-17cc7c8a.png";